var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-steps',{attrs:{"active":_vm.step}},[_c('el-step',{attrs:{"title":_vm.$t('Definir niveles de riesgo'),"description":""}}),_c('el-step',{attrs:{"title":_vm.$t('Definir flujos'),"description":""}}),_c('el-step',{attrs:{"title":_vm.$t('Registrar'),"description":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }